import React, { useEffect, useState } from 'react';
import axios from '../../config/axiosConfig';
import { MdAdd } from 'react-icons/md';

const DashboardNaiNews = ({ onAddClick, onEditClick }) => {
    const [newsList, setNewsList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            const response = await axios.get('nai-news/');
            setNewsList(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching news:", error);
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this news item?")) return;
        try {
            await axios.delete(`nai-news/${id}/`);
            setNewsList(prev => prev.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error deleting news:", error);
            alert("Failed to delete news item.");
        }
    };

    if (loading) return <div>Loading news...</div>;

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-800">NAI News</h2>
                <button
                    onClick={onAddClick}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center"
                >
                    <MdAdd className="mr-2" /> Add News
                </button>
            </div>

            <div className="w-full overflow-hidden">
                <table className="w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="w-16 px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Image</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Title</th>
                            <th className="w-28 px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Date</th>
                            <th className="w-28 px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {newsList.map((news) => (
                            <tr key={news.id} className="hover:bg-gray-50/70 transition-colors">
                                <td className="px-4 py-3 align-middle w-16">
                                    {news.image ? (
                                        <img src={news.image} alt={news.title} className="h-11 w-11 object-cover rounded shadow-sm" />
                                    ) : (
                                        <div className="h-11 w-11 bg-gray-100 rounded flex items-center justify-center text-xs text-gray-400">No img</div>
                                    )}
                                </td>
                                <td className="px-4 py-3 align-middle text-sm text-gray-900">
                                    <div className="line-clamp-2 sm:line-clamp-3 font-medium text-gray-800 leading-snug break-words">
                                        {news.title}
                                    </div>
                                </td>
                                <td className="px-4 py-3 align-middle whitespace-nowrap text-xs sm:text-sm text-gray-500">
                                    {new Date(news.created_at).toLocaleDateString()}
                                </td>
                                <td className="px-4 py-3 align-middle whitespace-nowrap text-sm font-medium text-right">
                                    <button 
                                        onClick={() => onEditClick(news.id)}
                                        className="text-blue-600 hover:text-blue-900 mr-3 font-semibold"
                                    >
                                        Edit
                                    </button>
                                    <button 
                                        onClick={() => handleDelete(news.id)}
                                        className="text-red-600 hover:text-red-900 font-semibold"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {newsList.length === 0 && (
                    <div className="text-center py-4 text-gray-500">No news found.</div>
                )}
            </div>
        </div>
    );
};

export default DashboardNaiNews;
